import * as React from 'react';
export const TransitionContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== 'production') {
  TransitionContext.displayName = 'TransitionContext';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/base/useTransition/TransitionContext.js
// module id = 1120
// module chunks = 0